export type LibraryFilter = 'recents' | 'favorites' | 'family' | 'private' | 'llm-private' | 'trash';

export type LibraryRow = {
  id: string;
  parentId: string | null;
  type: 'page' | 'database';
  title: string;
  icon: string | null;
  createdBy: string;
  updatedAt: string;
  deletedAt: string | null;
  source: 'family' | 'private';
  parentTitle: string | null;
  /** Recents: local visit time; favorites: starred time from API. */
  visitedAt?: string | null;
};

export const LIBRARY_FILTERS: LibraryFilter[] = [
  'recents',
  'favorites',
  'family',
  'private',
  'llm-private',
  'trash',
];

export const LIBRARY_FILTER_LABELS: Record<LibraryFilter, string> = {
  recents: 'Recents',
  favorites: 'Favorites',
  family: 'Family',
  private: 'Personal',
  'llm-private': 'Private',
  trash: 'Trash',
};

export function parseLibraryFilter(value: string | null | undefined): LibraryFilter {
  if (value && LIBRARY_FILTERS.includes(value as LibraryFilter)) {
    return value as LibraryFilter;
  }
  return 'recents';
}
